import { combineReducers } from "redux"
import applicationsReducer from "./applicationsReducer"
import metaReducer from "./metaReducer"
import { invoiceReducer } from "./invoiceReducer"
import applicationForExemptedReducer from "./applicationForExemptedReducer"
import applicationForReorderingOfCertificateReducer from "./applicationForReorderingOfCertificateReducer"
import teamsReducer from "./teamsReducer"
import errorCasesReducer from "./errorCaseReducer"
import companiesReducer from "./companiesReducer"
import commentsReducer from "./commentsReducer"

const appReducer = combineReducers({
    applicationForExempted: applicationForExemptedReducer,
    applicationForReorderingOfCertificate: applicationForReorderingOfCertificateReducer,
    applications: applicationsReducer,
    commments: commentsReducer,
    companies: companiesReducer,
    errorCases: errorCasesReducer,
    invoice: invoiceReducer,
    meta: metaReducer,
    teams: teamsReducer
})

export default (state: any, action: any) => {
    if (action.type === "RELOAD") {
        state = undefined
    }
    return appReducer(state, action)
}